import { RecuperarSenhaComponent } from './login/recuperar-senha/recuperar-senha.component';
import { DietasComponent } from './dietas/dietas.component';
import { NovoAcessoComponent } from './login/novo-acesso/novo-acesso.component';
import { PacienteGuard } from './guards/paciente.guard';
import { LoginComponent } from './login/login.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { PacientesGuard } from './guards/pacientes.guard';
import { DietasGuard } from './guards/dietas.guard';
import { AlteraSenhaGuard } from './guards/altera-senha.guard';

// controlador de rotas
// define qual componente será chamado de acordo com a rota passada

const rotas: Routes = [
    { 
        path: '', 
        component: DietasComponent,
        canActivate: [AuthGuard]
    },
    { 
        path: 'login', 
        component: LoginComponent 
    },
    { 
        path: 'novo', 
        component: NovoAcessoComponent 
    },
    { 
        path: 'recuperar-senha', 
        component: RecuperarSenhaComponent 
    },
    {
        path: 'pacientes', 
        loadChildren: 'app/pacientes/pacientes.module.ts#PacientesModule',
        canActivate: [AuthGuard],
        canActivateChild: [PacientesGuard]
    },
    {
        path: 'paciente', 
        loadChildren: 'app/paciente/paciente.module.ts#PacienteModule',
        canActivate: [AuthGuard],
        canActivateChild: [PacienteGuard]
    },
    {
        path: 'dietas',
        loadChildren: 'app/dietas/dietas.module.ts#DietasModule',
        canActivate: [AuthGuard],
        canActivateChild: [DietasGuard]
    },
    {
        path: 'altera-senha',
        loadChildren: 'app/altera-senha/altera-senha.module.ts#AlteraSenhaModule',
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(rotas)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRotasModule {}



// WEBPACK FOOTER //
// ./src/app/app.rotas.module.ts